import { render, staticRenderFns } from "./ITStartup.vue?vue&type=template&id=345aa4c1&"
import script from "./ITStartup.vue?vue&type=script&lang=js&"
export * from "./ITStartup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports